<template>
    <div>
        <Card shadow>
            <Row :gutter="18">
                <Col span="7" style="display:none">
                    <label style="display: flex; align-items: center">
                        <span style="width: 80px">代理组:</span>
                        <Select v-model="table.params.platids" filterable placeholder="筛选所属分组" clearable multiple :max-tag-count="2" @on-change="updateSelect">
                            <Option v-for="(item, index) in plat_list" :value="item.id" :label="item.name" :key="`platform_${item.id}_${index}`">
                                {{ item.name }}
                                <span style="color: #bbb">({{ item.id }})</span>
                            </Option>
                        </Select>
                    </label>
                </Col>
                <Col span="7">
                    <label style="display: flex; align-items: center">
                        <span style="width: 50px">代理:</span>
                        <Select v-model="table.params.app_ids" filterable placeholder="筛选代理" multiple :max-tag-count="3" clearable>
                            <Option v-for="(item, index) in app_list" v-show="table.params.platids.length == 0 || table.params.platids.includes(item.platform)" :value="item.appid" :label="item.appName" :key="`appid_${item.appid}_${index}`">
                                {{ item.appName }}
                                <span style="color: #bbb">({{ item.appid }})</span>
                            </Option>
                        </Select>
                    </label>
                </Col>

                <Col span="5">
                    <label style="display: flex; align-items: center">
                        <span style="width: 210px">请选择截至时间:</span>
                        <DatePicker class="DatePickerIview" :options="dateOptions" :clearable="false" type="date" v-model="select.dataTime" placement="bottom-end" placeholder="对比数据，请选择截至时间"></DatePicker>
                    </label>
                </Col>

                <Col span="5" style="display: flex; justify-content: space-between">
                    <Button type="primary" @click.native="TransTopReq()" :loading="loading" style="margin-right: 10px">
                        <span v-if="!loading">查询</span>
                        <span v-else>loading..</span>
                    </Button>
                    <div>
                        <Button type="primary" style="margin-right: 10px" @click.native="toExceltest()" :disabled="!canExportTable"> 导出Excel </Button>
                    </div>
                </Col>
            </Row>
        </Card>
        <Table border ref="tablenumber" :columns="table.columns" :data="table.data" :max-height="maxHeight" style="margin-top: 12px" @on-sort-change="sortChange" @on-expand="onExpand" :row-class-name="rowClassName" @on-row-click="handleTableClick" class="table-padding" @on-column-width-resize="widthResize"></Table>
        <Table border :columns="copyColumn" :data="copyDataList" style="display: none" ref="tableRef" class="table-padding"></Table>
    </div>
</template>
<script>
import { TransTopReq } from '@/api/admin/risk'
import moment from 'moment'
import publicTable from '@/views/components/publicTable.vue'
export default {
    name: 'dataRecord',
    components: { publicTable },
    data() {
        return {
            canExportTable: false,
            maxHeight: 720,
            loading: false,
            copyDataList: [],
            copyColumn: [],
            TransTopReqTimer: null,
            tempData: [],
            timestamp: -1,
            select: {
                dataTime: this.getCurrentZeroDay()
            },
            columnConfig: {
                general_id_text: {
                    name: '商户号',
                    tip: '商户号'
                },
                general_name: {
                    name: '商户名称(商户号)',
                    tip: '商户信息'
                },
                idate: { name: '日期', tip: '商户所属玩家当天日期' },
                pay_sum: { name: '转入金额', tip: '商户所属玩家当天总转入金额' },
                pay_user_num: { name: '转入人数', tip: '商户所属玩家，有转入用户数，去重' },
                put_sum: { name: '转出金额', tip: '商户所属玩家当天总转出金额' },
                loss_point: { name: '营收金额', tip: '营收金额 = 当天转入 - 当天提款 + 昨日余额 - 当天余额', showTrend: true },
                pay_bet_user_num: { name: '转入投注人数', tip: '商户所属玩家，历史上有转入且在当天有投注行为的用户数', showTrend: true },
                bet_sum: { name: '投注金额', tip: '商户所属玩家当天总投注金额' },
                loss_sum: { name: '游戏盈亏', tip: '商户所属玩家当天总盈亏金额' },
                percent_sum: { name: '税收金额', tip: '商户所属玩家当天的总税收金额' },
                percent_loss_rate: { name: '盈亏税收比', tip: '盈亏金额 / 税收金额' },
                loss_bet_rate: { name: '盈亏投注比', tip: '游戏盈亏 / 投注金额' },
                give_sum: { name: '赠送金额', tip: '商户所属玩家当天收到的赠送金额之和，包括注册绑定赠送、活动赠送、后台系统赠送', showTrend: true },
                new_user_num: { name: '新增用户数', tip: '商户所属玩家当天新增用户数' },
                new_bind_num: { name: '新增绑定用户数', tip: '商所属玩家当天新增玩家绑定手机号的人数' },
                active_num: { name: '活跃用户数', tip: '商户所属玩家当天登录用户数' },
                new_user_pay_num: { name: '新增转入人数', tip: '商户所属玩家当天新增并转入的人数' },
                new_pay_rate: { name: '新增转换率', tip: '新增用户转入人数 / 新增用户数' },
                new_pay_sum: { name: '新增转入金额', tip: '商户当天新增用户的总转入金额' },
                first_pay_num: { name: '首充人数', tip: '商户所属玩家当天首充用户数' },
                first_total_pay_sum: { name: '首充总金额', tip: '商户所属玩家当天首充总金额' },
                new_pay_first_pay: { name: '首充新增比', tip: '首充人数 / 新增人数' },
                send_percent_sum: { name: '佣金', tip: '商户所属玩家，当天收到系统发放的推广奖励金额之和' },
                send_percent_num: { name: '佣金发放人数', tip: '商户所属玩家，当天收到系统发放的推广奖励金额的用户数' },
                ci_ri_pay_num: { name: '新增转入次日复充人数', tip: '商户所属玩家，次日转入人数' },
                three_pay_num: { name: '新增转入3日复充人数', tip: '商户所属玩家，3日人数' },
                seven_pay_num: { name: '新增转入7日复充人数', tip: '商户所属玩家，7天人数' },
                ci_ri_pay_sum: { name: '新增转入次日复充金额', tip: '商户所属玩家，次日转入金额' },
                three_pay_sum: { name: '新增转入3日复充金额', tip: '商户所属玩家，3日复充金额' },
                seven_pay_sum: { name: '新增转入7日复充金额', tip: '商户所属玩家,7天转入金额' },
                // ci_ri_pay_rate: { name:'新增转入次日转入率', tip:'商户所属玩家，次日复充率'},
                // three_pay_rate: { name:'新增转入3日转入率', tip:'商户所属玩家，3日复充率'},
                // seven_pay_rate: { name:'新增转入7日转入率', tip:'商户所属玩家，7天转入率'},
                first_level_pay: { name: '一级首充人数', tip: '商户所属玩家，一级首充人数' },
                new_user_pay_one_times_num: { name: '新增仅转入1次人数', tip: '商户所属玩家，新增转入一次人数' },
                new_user_pay_one_times_sum: { name: '新增仅转入1次用户转入金额', tip: '商户所属玩家，新增转入一次金额数' },
                three_new_user_pay_one_times_num: { name: '3日前新增仅转入1次用户人数', tip: '商户所属玩家，3日前新增转入一次人数' },
                new_first_level_num: { name: '新增一级人数', tip: '当天注册且上级是0的人数' },
                first_level_pay_num: { name: '新增一级转入人数', tip: '当天注册且上级是0的用户当天转入人数' },
                first_level_pay_sum: { name: '新增一级转入总金额', tip: '当天注册且上级是0的用户当天转入金额' },
                first_ci_ri_pay_num: { name: '新充一级次日复充人数', tip: '当天注册且上级是0的用户第二天复充的人数' },
                first_ci_ri_pay_sum: { name: '新充一级次日复充金额', tip: '当天注册且上级是0的用户第二天复充的金额' },
                first_three_pay_num: { name: '新充一级3日复充人数', tip: '当天注册且上级是0的用户第3天复充的人数' },
                first_three_pay_sum: { name: '新充一级3日复充金额', tip: '当天注册且上级是0的用户第3天复充的金额' },
                first_seven_pay_num: { name: '新充一级7日复充人数', tip: '当天注册且上级是0的用户第7天复充的人数' },
                first_seven_pay_sum: { name: '新充一级7日复充金额', tip: '当天注册且上级是0的用户第7天复充的金额' },
                first_level_pay_count: { name: '新增一级用户转入次数', tip: '当天新增转入且无上级的用户当天成功转入次数' }
            },
            currentSortParam: {},
            expandId: null,
            table: {
                params: {
                    mod: 'root',
                    platid: 0,
                    platids: [],
                    app_id: 0,
                    app_name: '',
                    platform: 0,
                    app_ids: [],
                    param: {
                        _mod: 'manager',
                        _func: 'GetPlatformGeneralSumData',
                        _param: {
                            platid: 0,
                            app_id: 0,
                            stime: 0,
                            etime: 0
                        }
                    }
                },
                data: [],
                children: [],
                columns1: [],
                columns: [],
                total: 0,
                pageSizes: [10, 20, 30, 40]
            }
        }
    },
    methods: {
        //关闭定时器
        closeTimer() {
            this.loading = false
            clearTimeout(this.TransTopReqTimer)
            this.TransTopReqTimer = null
        },
        //批量请求开启定时器8秒超时
        openTimer() {
            this.closeTimer()
            this.loading = true
            this.TransTopReqTimer = setTimeout(() => {
                this.loading = false
            }, 6000)
        },
        toExcel() {
            let data = [...this.table.data]
            let arr = []
            for (let i in data) {
                let init = data[i]
                let item = this.copyData(init)
                let from = this.copyData(init.data || [])
                item.indexType = Number(i) + 1
                delete item.data
                arr.push(item)
                for (let k in from) {
                    let temp = from[k]
                    arr.push(temp)
                }
            }
            let column = this.getColumn(true)
            column.shift()
            this.copyDataList = arr
            this.copyColumn = column
            this.sortChangeByParams()
            this.$nextTick(async () => {
                await this.eleToExcel({
                    data: arr,
                    columns: column
                })
                this.copyDataList = []
                this.copyColumn = []
            })
        },
        toExceltest() {
            let data1 = JSON.parse(JSON.stringify(this.table.data))
            let arr = []
            data1.map((item) => {
                for (let i in item) {
                    if (i == 'general_id') {
                        item[i] = '合计'
                    } else if (i == 'app_name') {
                        if (item[i].indexOf('棋牌') > -1) {
                            item[i] = item[i].replace('棋牌', '')
                        } else if (item[i].indexOf('娱乐') > -1) {
                            item[i] = item[i].replace('娱乐', '')
                        }
                    } else if (i.includes('_rate')) {
                        item[i] = (item[i] * 100).toFixed(2) + '%'
                    } else if (i.includes('_num')) {
                        item[i] = item[i] == '-' ? '-' : item[i]
                    } else if (i.includes('_sum') || i.includes('_point')) {
                        item[i] = item[i] == '-' ? '-' : this.getCustomFixed(item[i] / 10000)
                    } else if (i == 'data') {
                        item[i].map((item1) => {
                            for (let k in item1) {
                                if (k.includes('_rate')) {
                                    item1[k] = (item1[k] * 100).toFixed(2) + '%'
                                } else if (k.includes('_sum') || k.includes('_point')) {
                                    item1[k] = item1[k] == '-' ? '-' : this.getCustomFixed(item1[k] / 10000)
                                } else if (k == 'app_name') {
                                    if (item1[k].indexOf('棋牌') > -1) {
                                        item1[k] = item1[k].replace('棋牌', '')
                                    } else if (item1[k].indexOf('娱乐') > -1) {
                                        item1[k] = item1[k].replace('娱乐', '')
                                    }
                                }
                            }
                        })
                    }
                }
            })
            let data = [...data1]
            for (let i in data) {
                let init = data[i]
                let item = this.copyData(init)
                let from = this.copyData(init.data || [])
                item.indexType = Number(i) + 1
                delete item.data
                arr.push(item)
                for (let k in from) {
                    let temp = from[k]
                    arr.push(temp)
                }
            }
            let column = this.getColumn(true)
            column.shift()
            this.$nextTick(async () => {
                this.$refs.tablenumber.exportCsv({
                    filename: '商户每日明细表',
                    columns: column,
                    data: arr
                })
                this.copyDataList = []
                this.copyColumn = []
            })
        },
        toPdf() {
            let item = this.table.columns.pop()
            let item3 = this.table.columns1.pop()
            this.maxHeight = null
            try {
                for (let i in this.table.data) {
                    this.$set(this.table.data[i], '_expanded', true)
                }
                this.$nextTick(async () => {
                    await this.eleToPdf()
                    this.maxHeight = 720
                    for (let i in this.table.data) {
                        this.$set(this.table.data[i], '_expanded', false)
                    }
                    this.table.columns.push(item)
                    this.table.columns1.push(item3)
                })
            } catch (error) {
                for (let i in this.table.data) {
                    this.$set(this.table.data[i], '_expanded', false)
                }
                this.table.columns.push(item)
                this.table.columns1.push(item3)
            }
        },

        async TransTopReq() {
            if (this.loading) return

            // let [stime, etime] = this.select.dataTime;
            this.table.params.param._param.stime = this.getSecond(this.select.dataTime)
            this.table.params.param._param.etime = this.getSecond(this.select.dataTime, false)

            this.openTimer()
            let allList = this.getAllHttpAppid(this.table.params)

            this.table.data = []
            this.tempData = []
            let dateMap = {}
            let all = {}
            let httpList = []
            let loadingArr = [...allList]
            let timestamp = new Date().getTime()
            for (let i = 0, len = allList.length; i < len; i++) {
                let app_id = allList[i]
                let app_name = ''
                let platid = 0
                let item = this.app_list.find((el) => el.appid == app_id)
                if (item) {
                    app_name = item.appName
                    platid = item.platform
                }
                this.table.params.platid = platid
                this.table.params.app_id = app_id
                this.table.params.app_name = app_name
                this.table.params.param._param.app_id = app_id
                this.table.params.param._param.platid = platid
                let param = this.copyData(this.table.params)
                param.timestamp = timestamp
                httpList.push(param)
            }
            this.timestamp = timestamp
            this.canExportTable = false
            for (let s = 0; s < 5; s++) {
                this.toHttp(httpList, dateMap, all, loadingArr)
            }
        },
        async toHttp(httpList, dateMap, all, loadingArr) {
            if (httpList.length > 0) {
                let param = httpList.shift()
                TransTopReq(param)
                    .then((res) => {
                        if (param.timestamp != this.timestamp) return
                        if (res._param) {
                            let params1 = this.copyData(param)
                            params1.param._func = 'GetPlatformGeneralSumData2'
                            let TotalData1 = res._param.data || []

                            //获取用户转入行为数据
                            TransTopReq(params1)
                                .then((res1) => {
                                    if (param.timestamp != this.timestamp) return
                                    let arrData = []
                                    let TotalData2 = res1._param.data || []
                                    if (TotalData2.length) {
                                        let { app_id, platid, app_name } = param
                                        app_name = param.app_name ? param.app_name.replace('棋牌', '').replace('娱乐', '') : ''
                                        TotalData2.map((v, i) => {
                                            if (TotalData1[i].general_id > -1) {
                                                TotalData1[i].general_name = TotalData1[i].general_name + `(${TotalData1[i].general_id})`
                                            } else {
                                                TotalData1[i].general_name = '合计'
                                            }
                                            TotalData1[i].general_id_text = `${TotalData1[i].general_id > -1 ? TotalData1[i].general_id : '合计'} `
                                            let obj = { ...v, ...TotalData1[i], app_name, idate: moment(this.select.dataTime).format('YYYY-MM-DD') }
                                            arrData.push(obj)
                                        })

                                        let obj = { data: arrData }
                                        Object.assign(
                                            obj,
                                            {
                                                app_id,
                                                platid,
                                                app_name,
                                                isParent: true
                                            },
                                            arrData[arrData.length - 1]
                                        )
                                        obj.data.pop()
                                        let newArray = [...this.tempData, obj]
                                        this.tempData = newArray
                                    }
                                    this.requestCallBack(loadingArr, dateMap, all, true)
                                    this.toHttp(httpList, dateMap, all, loadingArr)
                                })
                                .catch((err) => {
                                    this.errorHttp(param.timestamp)
                                })
                        }
                    })
                    .catch((err) => {
                        this.errorHttp(param.timestamp)
                    })
            }
        },
        errorHttp(timestamp) {
            if (this.timestamp == timestamp) {
                this.timestamp = 0
                this.tempData = []
                this.table.data = []
                this.closeTimer()
            }
        },
        getTrend(val1, val2) {
            return val1 < val2 ? 1 : val1 > val2 ? 2 : 3
        },
        requestCallBack(list, dateMap, all, insert = false) {
            list.shift()
            if (insert) {
                let index = this.tempData.findIndex((el) => el.app_id == -10)
                if (index != -1) this.tempData.splice(index, 1)
            }
            if (list.length == 0) {
                this.closeTimer()
                this.table.data = this.tempData
                if (this.table.data.length > 0) {
                    this.canExportTable = true
                }
            }
        },

        //获取显示趋势图标
        getTrendIcon(h, value) {
            if (!value) return
            return h('Icon', {
                props: {
                    type: value > 1 ? 'md-arrow-down' : 'md-arrow-up',
                    color: value > 1 ? '#32CD32' : 'red',
                    size: 16
                },
                style: {
                    marginLeft: '4px'
                }
            })
        },
        //分组变化清空盘口选择项
        updateSelect() {
            this.table.params.app_ids = []
        },

        sortChangeByParams() {
            if (this.currentSortParam.order) {
                let order = this.currentSortParam.order == 'desc' ? 1 : -1
                let key = this.currentSortParam.key
                this.copyDataList.sort((a, b) => {
                    if (a.app_id == -10) return 1
                    if (b.app_id == -10) return -1
                    return a[key] * order > b[key] * order ? -1 : 1
                })
            }
        },
        //table自定义排序方法
        sortChange(params) {
            this.currentSortParam = params
            this.table.data.filter((item, index) => {
                item['_expanded'] = false
                return item
            })
            let order = params.order == 'desc' ? 1 : -1
            let key = params.key
            this.table.data.sort((a, b) => {
                if (a.app_id == -10) return 1
                if (b.app_id == -10) return -1
                return a[key] * order > b[key] * order ? -1 : 1
            })
        },
        //获取表格cloumn isExpand:是否子数据
        getColumn(isExpand) {
            let arr = []
            for (let key in this.columnConfig) {
                let val = this.columnConfig[key]
                let item
                item = {
                    key,
                    align: 'center',
                    resizable: true,
                    width: 120,
                    title: val.name,
                    render: val.render,
                    renderHeader: (h) => this.renderHeader(h, val.name, val.tip)
                }
                if (key.includes('_rate')) {
                    Object.assign(item, {
                        width: 120,
                        render: (h, params) => h('span', [h('span', (params.row[key] * 100).toFixed(2) + '%')])
                    })
                } else if (key.includes('_num')) {
                    Object.assign(item, {
                        width: 120,
                        render: (h, params) => h('span', [h('span', params.row[key])])
                    })
                } else if (key.includes('_sum') || key.includes('_point')) {
                    Object.assign(item, {
                        width: 120,
                        render: (h, params) => h('span', [h('span', this.getCustomFixed(params.row[key] / 10000))])
                    })
                }
                arr.push(item)
            }
            return [
                isExpand
                    ? {
                          type: 'expand',
                          width: 38,
                          align: 'center',
                          render: (h, params) =>
                              h(publicTable, {
                                  props: {
                                      row: params.row.data,
                                      columns: this.table.columns1
                                  }
                              })
                      }
                    : {
                          width: 38,
                          align: 'center'
                      },
                // {
                //     type: 'index',
                //     title: '序号',
                //     width: 40,
                //     align: 'center',
                //     indexMethod: (el, val) => {
                //         if (!el.isParent) {
                //             return '';
                //         } else {
                //             return el._index != null ? el._index + 1 : el.indexType || '';
                //         }
                //     },
                // },
                {
                    key: 'app_name',
                    align: 'center',
                    width: 120,
                    title: '平台名称',
                    resizable: true,
                    render: (h, params) => {
                        let str = params.row.app_name
                        if (params.row.app_name.indexOf('棋牌') > -1) {
                            str = params.row.app_name.replace('棋牌', '')
                        } else if (params.row.app_name.indexOf('娱乐') > -1) {
                            str = params.row.app_name.replace('娱乐', '')
                        }
                        // let str = params.row.general_id < 0 ? '合计' : params.row.general_name ;
                        return h('span', str)
                    },
                    renderHeader: (h, params) => this.renderHeader(h, '平台名称', '显示统计信息对应的盘口名称')
                },
                // {
                //     key: 'plat_form',
                //     align: 'center',
                //     width:120,
                //     resizable: true,
                //     render: (h, params) => {

                //         if (params.row.plat_form_name) return h('span', params.row.plat_form_name);
                //         if(params.row.platid){
                //             let item = this.getAppInfo(params.row);
                //             return h('span', item ? item.name:"");
                //         }else{
                //             return h('span', "");
                //         }

                //     },
                //     renderHeader: (h, params) => (this).renderHeader(h, '所属分组', '显示对应盘口的所属平台'),
                // },
                ...arr
            ]
        },
        //当前点击展开的expandId
        //点击展开事件
        onExpand(row, status) {
            this.expandId = row.app_id
            let expand = this.table.data.find((el) => el._expanded)
            if (expand) this.$set(expand, '_expanded', false)
            if (status) {
                let newEx = this.table.data.find((el) => el.app_id == row.app_id)
                if (newEx) this.$set(newEx, '_expanded', true)
            }
        },
        //点击行事件
        handleTableClick(row, index) {
            let data = this.table.data[index]
            if (this.expandId == row.app_id) {
                if (!data._expanded) this.expandId = null
            } else {
                this.table.data[index]['_userCheck'] = !data._userCheck
            }
        },
        //设置行选中样式
        rowClassName(row, index) {
            let data = this.table.data[index]
            if (data._userCheck || data._expanded) return 'user-table-check'
            return ''
        },
        initFunc() {
            this.table.params.platids = [this.getinitPlatId()]
            this.TransTopReq()
        },
        getAppInfo(item) {
            return this.plat_list.find((el) => el.id == item.platid) || {}
        },
        widthResize(val, val1, val2) {
            let { key } = val2
            let find = this.table.columns1.find((el) => el.key == key)
            if (find) {
                find.width = val
            }
        }
    },

    created() {
        this.table.columns1 = this.getColumn(false)
        this.table.columns = this.getColumn(true)
        this.initFunc()
    }
}
</script>
<style lang="less" scoped>
.btn_batch {
    margin-right: 12px;
}
</style>
